export default __webpack_public_path__ + "static/media/Icon_Sign_out.ee9d16d1.svg";